import { graphql, PageProps } from 'gatsby';
import { last } from 'lodash-es';
import React from 'react';

// import { antiSlugify } from '../../shared/utils';


import "react-image-gallery/styles/css/image-gallery.css";
import { ProductPage } from '../../../components/products/page';
import { ProductHead } from '../../../components/products/seo';

type ProductDetailPageServerProps = {
  isSiteFramed: boolean;
  variant: string | null;
  origin: string;
}

// Commented out below as it was causing long load times on netlify
// export const getServerData: GetServerData<ProductDetailPageServerProps> = async ({ query, url, headers, params }) => {
//   const variant = (query?.variant as string) || null;
//   console.log('heree ProductDetailPageServerProps', headers, query, url, params, variant)
//   return {
//     props: {
//       isSiteFramed: query?.iframe === 'true',
//       variant: variant,
//       origin: (headers.get(':authority:') || headers.get('host')) as string
//     },
//   };
// }


export default function ProductDetailPage({ data, location }: PageProps<Queries.ProductDetailPageQuery, object, object, ProductDetailPageServerProps>) {
  const { product } = data
  const storefrontProduct = data.shopifyStorefront.products.nodes[0];
  const defaultVariant: Queries.ProductDetailPageQuery['product']['variants'][0] = last(product.variants);

  return (
    <ProductPage
      allowUrlVariantDetection={true}
      storeReviewCount={data.storeReviewCount}
      reviewList={data.reviewList}
      shopifyAdmin={data.shopifyAdmin}
      storeReviewRating={data.storeReviewRating}
      product={product}
      defaultVariant={defaultVariant}
      storefrontProduct={storefrontProduct}
      location={location}
    />
  );
}

export const Head = ({ data, location }: PageProps<Queries.ProductDetailPageQuery, any, any, ProductDetailPageServerProps>) => {
  const { product } = data
  const defaultVariant: Queries.ProductDetailPageQuery['product']['variants'][0] = last(product.variants);
  const storefrontProduct = data.shopifyStorefront.products.nodes[0];

  return (
    <ProductHead
      storeReviewCount={data.storeReviewCount}
      reviewList={data.reviewList}
      shopifyAdmin={data.shopifyAdmin}
      storeReviewRating={data.storeReviewRating}
      product={product}
      defaultVariant={defaultVariant}
      storefrontProduct={storefrontProduct}
      location={location}
    />
  )
}

export const query = graphql`
  query ProductDetailPage($handle: String!, $id: String!) {
    product: shopifyProduct(handle: { eq: $handle }) {
      ...ShopifyProductCard 
    
      seo1x1Image {
        preview {
          image {
            url
            height
            width
          }
        }
      }
      seo4x3Image {
        preview {
          image {
            url
            height
            width
          }
        }
      }
      seo16x9Image {
        preview {
          image {
            url
            height
            width
          }
        }
      }   
    }
    suggestions: allShopifyProduct(
      limit: 3
      # filter: { productType: { eq: $productType }, id: { ne: $id } }
      filter: { id: { ne: $id } }
    ) {
      nodes {
        ...ShopifyProductCard
      }
    }
    shopifyAdmin {
      products(first:1, query: $handle){
        nodes {
          metafields(first:1, namespace: "global") {
            nodes {
              ownerType,
              key,
              namespace,
              value          
            }
          }
        }
      }
    }    
    shopifyStorefront {
      products(first:1, query: $handle){
        nodes {
          id
          metafields(identifiers: [{key: "tabs", namespace: "custom"}, {key: "highlights", namespace: "custom"}, {key: "group_sku", namespace: "custom"}]) {
            id
            key
            value
            references(first: 250) {
                nodes {
                  ...on ShopifyStorefront_Metaobject {
                    fields {
                      key
                      value
                    }
                  }
                }
            }
          }
        }
      }
    }
    storeReviewCount: judgeMeStoreReviewsCount {
      all_reviews_count
    }
    storeReviewRating: judgeMeStoreReviewsRating {
      all_reviews_rating
    }
    reviewList: allCustomJudgeMeReviewsList {
      nodes {
        rating
        body
        featured
        title
        reviewer {
          name
        }
      }
    }
  }

  fragment ShopifyProductCard on ShopifyProduct {
    shopifyId
    storefrontId
    id
    hasOnlyDefaultVariant
    vendor
    descriptionHtml
    description
    tags  
    title
    handle
    productType

    # Used for Shopify analytics
    productGid: shopifyId
    name: title
    brand: vendor
    media {
      ... on ShopifyMediaImage {
        shopifyId
        image {
          altText
          localFile {
            childImageSharp {
                original: gatsbyImageData(
                  width: 600
                  quality: 100
                  layout: CONSTRAINED
                )
                thumbnail: gatsbyImageData(width: 60, height: 60, layout: FIXED, quality: 70)
            }
          }   
        }
      }
    }
    variants {
      id
      title
      shopifyId
      availableForSale
      storefrontId
      price
      sku
      presentmentPrices{
        compareAtPrice {
          amount
          currencyCode
        }
        price {
          amount
          currencyCode
        }
      }
      selectedOptions {
        name
        value
      }
      inventoryQuantity
    }
    options {
      name
      values
      id: shopifyId
    }
    priceRangeV2 {
      minVariantPrice {
        amount
        currencyCode
      }
      maxVariantPrice {
        amount
        currencyCode
      }
    }
  }
`
